import { isString, startCase } from 'lodash';
import { object, oneOfType, string } from 'prop-types';
import React from 'react';

const Option = ({ className, option, ...props }) => {
  const { value, label } = isString(option)
    ? { value: option, label: startCase(option) }
    : option;
  const classNames = `${className} e2e-${value}`;

  return label === 'Divider' ? (
    <option disabled>──</option>
  ) : (
    <option className={classNames} value={value} {...props}>
      {label}
    </option>
  );
};

Option.propTypes = {
  className: string,
  option: oneOfType([string, object])
};

Option.defaultProps = {
  className: ''
};

export default Option;
